import { useMutation } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { campaigns } from "../Services/api";

export default function useCampaignMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (payload) =>
      campaigns
        .post("/", payload, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then((res) => res.data),
  });
}
